<template>
  <div class="exportar-dados row">
    <div class="col-lg-12">
      <div class="container-cards">
        <CardExport
          v-for="(card, index) in cards"
          :key="index"
          :title="card.title"
          :subtitle="card.subtitle"
          :image="card.image"
          :itemsXls="card.itemsXls"
          :endpoint="generateEndpoint(card.endpoint)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CardExport from './Partials/CardExport/CardExport.vue'

export default {
  name: 'ExportarDados',
  components: { CardExport },

  data() {
    return {
      cards: [
        {
          title: 'Pré-natal',
          subtitle: 'Pré-natal, Odontologia, HIV e Sífilis.',
          image: {
            icon: false,
            value: require('@/assets/images/pregnant.png'),
          },
          itemsXls: {
            worksheet: 'pre-natal',
            name: 'pre-natal',
          },
          endpoint: 'app/exportar-dados/pre-natal/',
        },
        {
          title: 'Doenças crônicas',
          subtitle: 'Hipertenção e Diabetes',
          image: {
            icon: true,
            value: 'icofont-drug',
          },
          itemsXls: {
            worksheet: 'doencas-cronicas',
            name: 'doencas-cronicas',
          },
          endpoint: 'app/exportar-dados/doencas-cronicas/',
        },
        {
          title: 'Citopatológico',
          subtitle:
            'Coleta de citopatológicos em mulheres de 25 a 64 anos na APS',
          image: {
            icon: true,
            value: 'icofont-stretcher',
          },
          itemsXls: {
            worksheet: 'citopatologico',
            name: 'citopatologico',
          },
          endpoint: 'app/exportar-dados/citopatologico/',
        },
        // {
        //   title: 'Imunização',
        //   subtitle: 'Crianças até 1 ano',
        //   image: {
        //     icon: true,
        //     value: 'icofont-injection-syringe',
        //   },
        //   itemsXls: {
        //     worksheet: 'imunizacao',
        //     name: 'imunizacao',
        //   },
        //   endpoint: 'app/exportar-dados/imunizacao/',
        // },
      ],
    }
  },
  methods: {
    generateEndpoint(endpoint) {
      return `${endpoint}${this.$store.state.cod_ibge}`
    },
  },
}
</script>

<style src="./styles.scss" scoped lang="scss" />
